import React, {useRef} from "react";
import {EditActions} from "./EditActions";
import {DialogContent} from "@mui/material";
import {FormMetadata} from "../metadata/FormMetadata";
import {BatchEditProvider} from "../documents/batchEditContext";
import {Scroller} from "../app/Scroller";

// Approximate height (in px) of the EditActions (cancel/save) bar,
// used to make sure the scrollable content area doesn't overflow behind it.
const EDIT_ACTIONS_HEIGHT = 64;

/**
 * Renders the metadata edit form content together with the cancel/save actions.
 * Only the form content (DialogContent) is scrollable, while the actions stay
 * outside the scroll area. On small/mobile screens the actions are also
 * pinned ("sticky") to the bottom of the screen so they remain reachable
 * regardless of how tall the form content is.
 */
export const EditContentActionsBelow = ({isProjectObject, collectionId, panelHeight = 0, smallScreen}) => {
    const cardContentRef = useRef(null);
    return (
        <>
            <Scroller initialHeight={panelHeight + "px"} subtractFromHeight={EDIT_ACTIONS_HEIGHT}>
                <DialogContent ref={cardContentRef} sx={{overflowY: "auto"}}>
                    <BatchEditProvider>
                        <FormMetadata isProjectObject={isProjectObject} collectionId={collectionId} batchEdit={false}/>
                    </BatchEditProvider>
                </DialogContent>
            </Scroller>
            <EditActions smallScreen={smallScreen}/>
        </>
    );
};
